// Lazy loader for Google Translate.
// IMPORTANT: we deliberately do NOT load translate.google.com on the default
// (English) page load. Loading it for every visitor made security scanners
// (e.g. Spectrum/CUJO "Security Shield") flag the domain, because the
// translate_a/element.js injector is commonly abused by cloaking/phishing kits.
// Instead we inject it on demand ONLY when a visitor chooses a non-English
// language, so the baseline page a scanner fetches contains no third-party
// translation injector. Spanish (and other languages) still work fully.
let injected = false;

export function loadGoogleTranslate() {
  if (injected || typeof window === "undefined") return;
  injected = true;
  window.googleTranslateElementInit = function () {
    /* global google */
    // eslint-disable-next-line no-undef
    new google.translate.TranslateElement(
      {
        pageLanguage: "en",
        includedLanguages: "es,en,fr,zh-CN,vi,ar,hi",
        // eslint-disable-next-line no-undef
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
        autoDisplay: false,
      },
      "google_translate_element",
    );
  };
  const s = document.createElement("script");
  // Explicit https (never protocol-relative) to avoid any insecure-load flag.
  s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  s.async = true;
  document.body.appendChild(s);
}
